import { get } from 'lodash';
import { getMoment } from './dates';

export const chain = (...funcs) => {
  return funcs.reduce(
    (a, b) =>
      (...args) =>
        b(a(...args)),
    (arg) => arg,
  );
};

const deg2rad = (deg) => (deg * Math.PI) / 180;

export const getDistanceKM = ({ c1, c2 }) => {
  const R = 6371; // Radius of the earth in km
  const { latitude: lat1, longitude: lon1 } = c1;
  const { latitude: lat2, longitude: lon2 } = c2;
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
};

const getValuesOfType = (
  fields = [],
  inputtedFields = [],
  type,
  formatValue = (x) => x,
) =>
  fields.reduce((acc, field) => {
    if (field.type === type) {
      const inputtedField = inputtedFields.find((f) => f._id === field._id);
      if (inputtedField && inputtedField.value) {
        return [
          ...acc,
          {
            _id: field._id,
            name: field.name,
            value: formatValue(inputtedField.value),
          },
        ];
      }
    }
    return acc;
  }, []);

export const formatReview = (review, type = 'from') => {
  const {
    _id,
    form,
    fields,
    createdAt,
    [type]: user,
    visible,
  } = review;

  const numericFields = getValuesOfType(
    get(form, 'fields'),
    fields,
    'RATING5',
    (x) => parseInt(x, 10),
  );
  const textFields = getValuesOfType(
    get(form, 'fields'),
    fields,
    'MULTILINE_TEXT',
  );

  let name = user ? `${user.first} ${user.last}` : null;

  return {
    _id,
    avatar: get(user, 'avatar'),
    name,
    textFields,
    numericFields,
    visible,
    date: getMoment(createdAt.timestamp),
  };
};

// reviews from map(r => formatReview(r))
export const reviewsData = (reviews) => {
  const data = reviews.reduce((acc, review) => {
    review.numericFields.forEach((field) => {
      const { name, value } = field;
      if (!acc[name]) {
        acc[name] = { sum: 0, count: 0 };
      }
      acc[name].sum += value;
      acc[name].count += 1;
    });

    return acc;
  }, {});

  const averages = Object.keys(data).reduce((acc, key) => {
    const { sum, count } = data[key];
    return {
      ...acc,
      [key]: count > 0 ? sum / count : -1,
    };
  }, {});

  const overallSum = Object.keys(data).reduce((acc, key) => {
    return acc + data[key].sum;
  }, 0);

  const overallCount = Object.keys(data).reduce((acc, key) => {
    return acc + data[key].count;
  }, 0);

  const overallAve = overallCount > 0 ? overallSum / overallCount : -1;

  return {
    count: reviews.length,
    averages,
    overall: overallAve,
  };
};

export const getAverage = fields => {
  if (fields.length === 0) {
    return -1;
  }

  const sum = fields.reduce((acc, field) => acc + field.value, 0);

  return sum / fields.length;
};



// WEBPACK FOOTER //
// ./src/util/misc.js